// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LayoutRegisterPage_wrap__Cjd62","wrap-body":"LayoutRegisterPage_wrap-body__4rBO_"};